<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    wrapperClass?: HTMLAttributes['class']
    ringClass?: HTMLAttributes['class']
    iconWrapperClass?: HTMLAttributes['class']
    icon?: string
    iconSize?: string
    title?: string
    description?: string
    disableBackgroundStyle?: boolean
    titleClass?: HTMLAttributes['class']
    descriptionClass?: HTMLAttributes['class']
    radialColor?: string
  }>(),
  {
    class: undefined,
    wrapperClass: undefined,
    ringClass: undefined,
    iconWrapperClass: undefined,
    icon: undefined,
    title: undefined,
    description: undefined,
    titleClass: undefined,
    descriptionClass: undefined,
    iconSize: '24px',
    disableBackgroundStyle: false,
    radialColor: 'var(--color-primary)'
  }
)
</script>

<template>
  <div
    :class="
      cn(
        'p-1.5 overflow-hidden shadow bg-surface-container-low group relative rounded-2xl select-none',
        props.class
      )
    "
  >
    <slot name="flag" />
    <div
      :class="
        cn(
          'p-5 h-full flex flex-col gap-3 items-start relative rounded-xl bg-background shadow',
          {
            'items-center': !description && icon
          },
          props.wrapperClass
        )
      "
    >
      <slot>
        <div
          :class="
            cn('flex justify-between gap-3 lg:gap-5 items-start', {
              'items-center': !description && icon
            })
          "
        >
          <UiIconWrapper
            v-if="icon"
            :icon="icon"
            :size="iconSize"
            :class="props.iconWrapperClass"
          />

          <div class="flex flex-col gap-1">
            <h3 :class="cn('font-semibold lg:text-lg', props.titleClass)">
              {{ title }}
            </h3>

            <p
              v-if="description"
              :class="cn('text-current/70', props.descriptionClass)"
            >
              {{ description }}
            </p>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
